import { isRequestCanceled } from '@/utils/isRequestCanceled';

function mapGroupedStatisticsResponse(res, groups = []) {
  const data = (res.stats || []).map((el) => {
    return {
      _keys: el.keys,
      ...el.dimensions,
      ...el.metrics,
    };
  });

  data.forEach((el) => {
    groups.forEach((group) => {
      if (el[group] === undefined) {
        el[group] = 'None';
      }
    });
    return el;
  });

  return {
    data: data || [],
    totals: res.totals || {},
    sql: res.querySql || [],
    metadata: res.metadata || null,
  };
}

export default {
  fetchSegments({ commit, state }, data = {}) {
    if (Object.keys(state.segments).length > 0 && !data.refresh) {
      return state.segments;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/stats/segments', params).then((res) => {
      const response = !res ? [] : res.segments;
      commit('SET_SEGMENTS', response);
      return response;
    });
  },
  fetchMetrics({ commit }, reportId) {
    return this.$api.adnet.get('/stats/metrics', { params: { code: reportId } }).then((res) => {
      commit('SET_METRICS', res.metrics);
    });
  },
  fetchDimensions({ commit }, reportId) {
    return this.$api.adnet.get('/stats/dimensions', { params: { code: reportId } }).then((res) => {
      commit('SET_DIMENSIONS', res.dimensions);
    });
  },
  fetchReports({ commit }) {
    return this.$api.adnet.get('/stats/reports').then((res) => {
      let filteredReports = res.reports.filter((report) => report.categoryCode !== 'hidden');
      commit('SET_REPORTS', filteredReports);
    });
  },
  fetchSubReports({ commit }, reportId) {
    return this.$api.adnet.get(`/stats/sub-reports/${reportId}`).then((res) => {
      return res['sub_reports'];
    });
  },
  fetchMultizones({ commit }) {
    return this.$api.adnet
      .get('/stats/zones/multi-zones')
      .then((res) => {
        return res.zones || [];
      })
      .catch((e) => {
        return [];
      });
  },
  fetchStatistics: (function () {
    let cancelStatisticFetching;
    return function (arg, params) {
      if (typeof cancelStatisticFetching === 'function' && params.disableCancel != true) {
        cancelStatisticFetching();
      }

      let queryParams = {
        q: params.q,
      };
      if (params.paginate) {
        Object.keys(params.paginate).forEach((key) => {
          queryParams[key] = params.paginate[key];
        });
      }

      return this.$api.adnet
        .get('/stats/grouped', {
          params: queryParams,
          cancelToken: new this.$api.client.CancelToken(function executor(c) {
            cancelStatisticFetching = c;
          }),
        })
        .then((res) => {
          if (!res || !Array.isArray(res.stats)) {
            console.error('[stats/grouped] Invalid server response: expected { stats: [...] }, got:', res, 'for query:', params.q);
            throw new Error('Server returned an invalid response. Please try again or contact support if the problem persists.');
          }
          const data = res.stats.map((el) => {
            return {
              _keys: el.keys,
              ...el.dimensions,
              ...el.metrics,
            };
          });
          data.forEach((el) => {
            params.q.groups.forEach((group) => {
              if (el[group] === undefined) {
                el[group] = 'None';
              }
            });
            return el;
          });
          return {
            data: data || [],
            totals: res.totals || {},
            sql: res.querySql || [],
            metadata: res.metadata || null,
          };
        })
        .catch((error) => {
          if (!this.$api.client.isCancel(error)) {
            throw error;
          }
        });
    };
  })(),
  fetchStatisticsPOST: (function () {
    let activeRequestController;
    return function (arg, params) {
      if (activeRequestController) {
        activeRequestController.abort();
      }

      const controller = new AbortController();
      activeRequestController = controller;

      return this.$api.adnet
        .post('/stats/grouped', params, { signal: controller.signal })
        .then((res) => {
          if (activeRequestController === controller) {
            activeRequestController = null;
          }

          return mapGroupedStatisticsResponse(res, params.groups);
        })
        .catch((error) => {
          if (activeRequestController === controller) {
            activeRequestController = null;
          }

          if (isRequestCanceled(error)) {
            throw error;
          }

          throw error;
        });
    };
  })(),
  // this is temporary
  fetchStatisticsBid: (function () {
    let activeRequestController;
    return function (arg, params) {
      if (activeRequestController) {
        activeRequestController.abort();
      }

      const controller = new AbortController();
      activeRequestController = controller;

      return this.$api.adnet
        .post('/stats/grouped', params, { signal: controller.signal })
        .then((res) => {
          if (activeRequestController === controller) {
            activeRequestController = null;
          }

          return mapGroupedStatisticsResponse(res, params.groups);
        })
        .catch((error) => {
          if (activeRequestController === controller) {
            activeRequestController = null;
          }

          if (isRequestCanceled(error)) {
            throw error;
          }

          throw error;
        });
    };
  })(),
  fetchStatisticsNoCancel(arg, params) {
    return this.$api.adnet
      .get('/stats/grouped', {
        params: params,
      })
      .then((res) => {
        const data = res.stats.map((el) => {
          return {
            _keys: el.keys,
            ...el.dimensions,
            ...el.metrics,
          };
        });
        data.forEach((el) => {
          params.q.groups.forEach((group) => {
            if (el[group] === undefined) {
              el[group] = 'None';
            }
          });
          return el;
        });
        return {
          data: data || [],
          totals: res.totals || {},
          sql: res.querySql || [],
          metadata: res.metadata || null,
        };
      });
  },
};
